<template>
  <div class="create-batch-check-order-job">
    <div class="content" style="min-height: 0">
      <a-tabs default-active-key="basicInformation" @change="changeTabs">
        <a-tab-pane key="basicInformation" :tab="$t(`form.BasicInformation`)"></a-tab-pane>
        <a-tab-pane key="accountInformation" :tab="$t(`form.AccountInformation`)"></a-tab-pane>
        <a-tab-pane
          key="qualificationInformation"
          :tab="$t(`form.QualificationInformation`)"
        ></a-tab-pane>
        <a-tab-pane key="paymentPlanSettings" :tab="$t('付款计划设置')"></a-tab-pane>
      </a-tabs>
    </div>
    <div class="content-overflow mt10">
      <section class="left-div fixContent" :style="{ height: scrollHeight }">
        <a-form-model ref="ruleForm" :model="formData">
          <div id="basicInformation" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                <span>{{ $t(`form.BasicInformation`) }}</span>
              </div>
              <a-button
                type="primary"
                v-if="isEdit && formData.status === 0 && !isShow"
                @click="updateStatusFn(1)"
              >
                {{ $t(`form.Enable`) }}
              </a-button>
              <a-button
                type="danger"
                @click="updateStatusFn(0)"
                v-if="isEdit && formData.status === 1 && !isShow"
              >
                {{ $t(`form.Deactivate`) }}
              </a-button>
            </div>
            <a-row class="flex-row" :gutter="24">
              <a-col :span="8" v-if="merchantList.length > 0">
                <a-form-model-item :label="$t(`关联商户`)">
                  <a-select
                    allowClear
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :placeholder="$t(`关联商户`)"
                    v-model="formData.referMerchantCode"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="item in merchantList"
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.SupplierName`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.supplierName"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.SupplierName`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.SupplierAddress`)" :required="true">
                  <a-cascader
                    v-model="delivery"
                    :options="options"
                    :load-data="loadData"
                    :disabled="isEdit && (!isEdit || !isShow)"
                    @change="selectSupplierAddress"
                    :field-names="{
                      label: 'display_name',
                      value: 'region_id',
                      children: 'children',
                    }"
                    :placeholder="$t(`form.AddressDetail`)"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.Postcode`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.postCode"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.Postcode`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.SupplierDetailedAddress`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.address"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.SupplierDetailedAddress`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.Contacts`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.linkman"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.Contacts`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  ref="mobile"
                  :required="true"
                  :label="$t(`form.ContactInformation`)"
                >
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.mobile"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.ContactInformation`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('邮箱')">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.email"
                    :placeholder="$t(`请输入邮箱`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.BizMode`)">
                  <a-select
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :placeholder="$t(`form.pleaseChoose`) + $t(`form.BizMode`)"
                    style="width: 100%"
                    v-model="formData.bizMode"
                  >
                    <a-select-option :key="key" :value="key" v-for="(item, key) in bizModeList">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.SupplierTaxNo`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.taxId"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.SupplierTaxNo`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="hasFMSApp">
                <a-form-model-item :label="$t(`结算组织`)">
                  <SelectBU
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :code.sync="formData.businessUnitCode"
                    :name.sync="formData.businessUnitName"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.BriefIntroduction`)">
                  <a-textarea
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BriefIntroduction`)"
                    auto-size
                    v-model="formData.description"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" v-if="isRent">
                <a-form-model-item :label="$t(`form.Warehouse`)">
                  <template v-if="isEdit">
                    <a-button
                      type="primary"
                      size="small"
                      :disabled="isEdit && (!isEdit || !isShow)"
                      @click="openWarehouseModal"
                    >
                      {{ $t('添加仓库') }}
                    </a-button>
                    <a-table
                      v-if="formData.warehouseList && formData.warehouseList.length"
                      style="margin-top: 8px"
                      :columns="warehouseTableColumns"
                      :data-source="formData.warehouseList"
                      :pagination="false"
                      rowKey="uniqueCode"
                      size="small"
                    >
                      <span slot="defaultWarehouse" slot-scope="text, record">
                        <a-tag v-if="record.defaultWarehouse === 1" color="blue">
                          {{ $t('默认') }}
                        </a-tag>
                        <span
                          style="cursor: pointer; color: #1890ff"
                          v-if="(!isEdit || isShow) && record.defaultWarehouse !== 1"
                          @click="setDefaultWarehouse(record)"
                        >
                          {{ $t('设为默认仓库') }}
                        </span>
                      </span>
                    </a-table>
                  </template>
                  <template v-else>
                    <div style="display: flex; align-items: center; gap: 8px">
                      <span>{{ $t('是否支持一件代发') }}：</span>
                      <a-switch v-model="supportDropshipping" />
                      <!-- <span style="color: rgba(0, 0, 0, 0.45)">开启后创建代发仓并关联实体仓</span> -->
                    </div>
                  </template>
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="isRent">
                <a-form-model-item :label="$t('退货仓')">
                  <a-button
                    type="primary"
                    size="small"
                    :disabled="isEdit && (!isEdit || !isShow)"
                    @click="openReturnWarehouseModal('RETURN_WAREHOUSE')"
                  >
                    {{ $t('选择仓库') }}
                  </a-button>
                  <span
                    v-if="getSelectedReturnWarehouse('RETURN_WAREHOUSE')"
                    style="margin-left: 8px"
                  >
                    {{ getSelectedReturnWarehouse('RETURN_WAREHOUSE').warehouseCode }} -
                    {{ getSelectedReturnWarehouse('RETURN_WAREHOUSE').warehouseName }}
                    <a
                      v-if="!isEdit || isShow"
                      style="margin-left: 8px"
                      @click="clearReturnWarehouse('RETURN_WAREHOUSE')"
                    >
                      {{ $t('清除') }}
                    </a>
                  </span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="isRent">
                <a-form-model-item :label="$t('拦截退回仓')">
                  <a-button
                    type="primary"
                    size="small"
                    :disabled="isEdit && (!isEdit || !isShow)"
                    @click="openReturnWarehouseModal('INTERCEPT_RETURN_WAREHOUSE')"
                  >
                    {{ $t('选择仓库') }}
                  </a-button>
                  <span
                    v-if="getSelectedReturnWarehouse('INTERCEPT_RETURN_WAREHOUSE')"
                    style="margin-left: 8px"
                  >
                    {{ getSelectedReturnWarehouse('INTERCEPT_RETURN_WAREHOUSE').warehouseCode }}
                    -
                    {{ getSelectedReturnWarehouse('INTERCEPT_RETURN_WAREHOUSE').warehouseName }}
                    <a
                      v-if="!isEdit || isShow"
                      style="margin-left: 8px"
                      @click="clearReturnWarehouse('INTERCEPT_RETURN_WAREHOUSE')"
                    >
                      {{ $t('清除') }}
                    </a>
                  </span>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div id="accountInformation" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                {{ $t('form.AccountInformation') }}
              </div>
            </div>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.BankOfDeposit`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.bankName"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BankOfDeposit`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.BankAccount`)" :required="true">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.bankAccount"
                    @input="formData.bankAccount = formData.bankAccount.replace(/[^\d]/g, '')"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BankAccount`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.BankCardholder`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.bankCardholder"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BankCardholder`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.ContactInformationOfCardholder`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.cardholderMobile"
                    :placeholder="
                      $t(`form.PleaseEnter`) + $t(`form.ContactInformationOfCardholder`)
                    "
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.BankAddress`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.bankAddress"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BankAddress`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.SWIFTcode`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.swiftCode"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.SWIFTcode`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :required="true" :label="$t(`form.Currency`)">
                  <a-select
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :placeholder="$t(`form.pleaseChoose`) + $t(`form.Currency`)"
                    style="width: 100%"
                    v-model="formData.currency"
                  >
                    <a-select-option :value="item" v-for="item in currencyMap" :key="item">
                      {{ $t(`form.${item}`) }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.VATRate`) + '(%)'">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.vatRate"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.VATRate`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div id="qualificationInformation" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                <span>{{ $t(`form.QualificationInformation`) }}</span>
              </div>
            </div>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.BusinessLicenseNo`)">
                  <a-input
                    :disabled="isEdit && (!isEdit || !isShow)"
                    v-model="formData.businessLicenseNo"
                    @input="
                      formData.businessLicenseNo = formData.businessLicenseNo.replace(/[^\w_]/g, '')
                    "
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.BusinessLicenseNo`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item>
                  <upload-image
                    :disabled="isEdit && (!isEdit || !isShow)"
                    :multiple="1"
                    :imageList.sync="businessLicenseList"
                    :showText="$t(`form.UploadBusinessLicense`)"
                    biz="supplier"
                  ></upload-image>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.IDCardPhoto`)">
                  <div style="display: flex">
                    <upload-image
                      :disabled="isEdit && (!isEdit || !isShow)"
                      :multiple="1"
                      :imageList.sync="idCardFrontList"
                      :showText="$t(`form.UploadPortrait`)"
                      biz="supplier"
                    ></upload-image>
                    <upload-image
                      :disabled="isEdit && (!isEdit || !isShow)"
                      :multiple="1"
                      :imageList.sync="idCardReverseList"
                      :showText="$t(`form.UploadNationaEmblem`)"
                      biz="supplier"
                    ></upload-image>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.OtherAccessories`)">
                  <div style="display: flex">
                    <upload-image
                      accept="*"
                      :disabled="isEdit && (!isEdit || !isShow)"
                      :multiple="10"
                      :imageList.sync="otherAttachmentsList"
                      biz="supplier"
                    ></upload-image>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <!-- 付款计划设置 -->
          <div id="paymentPlanSettings" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                <span>{{ $t('付款计划设置') }}</span>
              </div>
              <div v-if="!isEdit || isShow">
                <a-button size="small" type="primary" @click="addPaymentPlanSetting">
                  {{ $t('增行') }}
                </a-button>
              </div>
            </div>
            <a-table
              :columns="paymentPlanSettingColumns"
              :data-source="paymentPlanSettings"
              :pagination="false"
              size="small"
              :rowKey="(record, index) => index"
              style="margin-top: 8px"
            >
              <template slot="isPrepay" slot-scope="text, record">
                <a-select
                  v-model="record.isPrepay"
                  style="width: 100%"
                  :disabled="isEdit && !isShow"
                >
                  <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                  <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                </a-select>
              </template>
              <template slot="ratio" slot-scope="text, record">
                <a-input-number
                  v-model="record.ratio"
                  :min="0.01"
                  :max="100"
                  style="width: 100%"
                  :placeholder="$t('请输入支付比例')"
                  :disabled="isEdit && !isShow"
                />
              </template>
              <template slot="action" slot-scope="text, record, index">
                <a-icon
                  v-if="!isEdit || isShow"
                  type="delete"
                  style="color: red; cursor: pointer"
                  @click="removePaymentPlanSetting(index)"
                />
              </template>
            </a-table>
          </div>
        </a-form-model>
      </section>
    </div>

    <div class="content" style="min-height: 0">
      <a-row type="flex" justify="center">
        <a-col>
          <a-row type="flex" justify="start" :gutter="16">
            <a-button
              type="primary"
              v-if="isEdit && (!isEdit || !isShow)"
              @click="isShow = !isShow"
            >
              {{ $t(`form.Edit`) }}
            </a-button>
            <a-button
              type="primary"
              v-if="!isEdit || isShow"
              @click="onSubmit"
              :loading="saveLoading"
            >
              {{ $t(`form.Save`) }}
            </a-button>
            <a-button type="default" v-if="isEdit && (!isEdit || isShow)" @click="cancelEdit">
              {{ $t(`form.Cancel`) }}
            </a-button>
            <a-button type="default" v-if="!isEdit || !isShow" @click="backForm">
              {{ $t(`form.Back`) }}
            </a-button>
          </a-row>
        </a-col>
      </a-row>
    </div>
    <a-modal
      class="modalA"
      :title="$t('选择仓库')"
      :visible="warehouseModalVisible"
      :confirm-loading="warehouseTableLoading"
      @ok="handleWarehouseModalOk"
      @cancel="handleWarehouseModalCancel"
      :destroy-on-close="true"
      :mask-closable="false"
      width="700px"
    >
      <a-table
        :loading="warehouseTableLoading"
        :columns="warehouseModalColumns"
        :data-source="allWarehouseList"
        rowKey="uniqueCode"
        :pagination="false"
        size="small"
        :rowSelection="{
          selectedRowKeys: warehouseModalSelectedRowKeys,
          onChange: onWarehouseModalSelectChange,
        }"
      ></a-table>
    </a-modal>
    <a-modal
      class="modalA"
      :title="returnWarehouseModalTitle"
      :visible="returnWarehouseModalVisible"
      :confirm-loading="warehouseTableLoading"
      @ok="handleReturnWarehouseModalOk"
      @cancel="handleReturnWarehouseModalCancel"
      :destroy-on-close="true"
      :mask-closable="false"
      width="700px"
    >
      <a-table
        :loading="warehouseTableLoading"
        :columns="warehouseModalColumns"
        :data-source="allWarehouseList"
        rowKey="uniqueCode"
        :pagination="false"
        size="small"
        :rowSelection="{
          type: 'radio',
          selectedRowKeys: returnWarehouseModalSelectedRowKeys,
          onChange: onReturnWarehouseModalSelectChange,
        }"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapState } from 'vuex'
import uploadImage from '@component/uploadImage'
import SelectBU from '@component/selectBU'
import { getCookie } from '@/common/cookie'
import { Cascader } from 'ant-design-vue'
import debounce from '@/common/debounce'
export default {
  name: 'addSupplier',
  components: {
    uploadImage,
    SelectBU,
    'a-cascader': Cascader,
  },
  data() {
    return {
      isEdit: false,
      isShow: false,
      supportDropshipping: false,
      formData: {
        currency: 'THB',
        vatRate: undefined,
        warehouseList: [],
        returnWarehouseList: [],
      },
      paymentPlanSettings: [],
      data: [],
      sessionId: '',
      pageNo: 1,
      pageSize: 20,
      loading: false,
      options: [],
      type: 0,
      parentId: '0',
      businessLicenseList: [], //营业资格
      idCardFrontList: [], //身份证正面
      idCardReverseList: [], //身份证背面
      otherAttachmentsList: [], //其他附件
      delivery: [], //地址
      addressNameList: [],
      express_company: 'J&T', //快递平台
      express_account: '', //快递账号
      express_secret: '', //快递密钥
      express_code: '', //快递码
      postcode: '', //邮编
      shippingAddress: [], //发货地址
      shippimgAddressVal: '', //发货地址
      sender_address: '', //发货详细地址
      shop_code: '', //店铺编码
      warehouse_code: '', //仓库编码
      shipper_code: '', //货主编码
      deliveryArr: [],
      saveLoading: false,
      merchantList: [],
      warehouseModalVisible: false,
      allWarehouseList: [],
      warehouseTableLoading: false,
      warehouseModalSelectedRowKeys: [],
      returnWarehouseModalVisible: false,
      returnWarehouseModalType: '',
      returnWarehouseModalSelectedRowKeys: [],
      RETURN_WAREHOUSE_TYPE_MAP: {
        RETURN_WAREHOUSE: '退货仓',
        INTERCEPT_RETURN_WAREHOUSE: '拦截退回仓',
      },
      warehouseTableColumns: [
        {
          title: this.$t('仓库编码'),
          dataIndex: 'warehouseCode',
          key: 'warehouseCode',
        },
        {
          title: this.$t('仓库名称'),
          dataIndex: 'warehouseName',
          key: 'warehouseName',
        },
        {
          title: this.$t('默认仓'),
          dataIndex: 'defaultWarehouse',
          key: 'defaultWarehouse',
          scopedSlots: { customRender: 'defaultWarehouse' },
        },
      ],
      warehouseModalColumns: [
        {
          title: this.$t('仓库编码'),
          dataIndex: 'code',
          key: 'code',
        },
        {
          title: this.$t('仓库名称'),
          dataIndex: 'name',
          key: 'name',
        },
      ],
      paymentPlanSettingColumns: [
        {
          title: this.$t('是否预付'),
          dataIndex: 'isPrepay',
          scopedSlots: { customRender: 'isPrepay' },
          width: 140,
        },
        {
          title: this.$t('支付比例') + '(%)',
          dataIndex: 'ratio',
          scopedSlots: { customRender: 'ratio' },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: 80,
        },
      ],
    }
  },
  mounted() {
    this.sessionId = getCookie('d_session_id')
    this.getDetail()
    this.getMerchantRefetList()
    http({
      url: api.getRegionAdd,
      type: 'post',
      data: {
        regionType: '0',
        parentId: '0',
      },
      success: (res) => {
        let data = res.result
        if (this.currentShop) {
          if (this.currentShop.country === 'CN') {
            //中国店铺只展示中国选项就够了
            data = data.filter((item) => item.region_id === 6)
          }
        }
        this.options = data.map((item) => {
          item.isLeaf = false
          return item
        })
      },
    })
    if (this.$route.query.from) {
      this.isShow = true
    }
  },
  computed: {
    ...mapState(['bizModeList', 'currentShop', 'currencyMap']),
    isRent() {
      return !!this.$store.getters.isRent
    },
    scrollHeight() {
      let height = window.innerHeight - 300
      return height * this.$store.state.rate + 'px'
    },
    hasFMSApp() {
      let currentIdaasApp = JSON.parse(localStorage.getItem('currentIdaasApp') || '{}')
      return !!currentIdaasApp['FMS']
    },
    returnWarehouseModalTitle() {
      const typeName =
        this.RETURN_WAREHOUSE_TYPE_MAP[this.returnWarehouseModalType] || this.$t('选择仓库')
      return this.$t('选择') + typeName
    },
  },
  methods: {
    openReturnWarehouseModal(type) {
      this.returnWarehouseModalType = type
      this.returnWarehouseModalVisible = true
      this.fetchAllWarehouseList()
      const current = this.getSelectedReturnWarehouse(type)
      this.returnWarehouseModalSelectedRowKeys = current?.uniqueCode ? [current.uniqueCode] : []
    },
    onReturnWarehouseModalSelectChange(selectedRowKeys) {
      this.returnWarehouseModalSelectedRowKeys = selectedRowKeys
    },
    handleReturnWarehouseModalOk() {
      const selectedKey = (this.returnWarehouseModalSelectedRowKeys || [])[0]
      if (!selectedKey) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('请选择仓库'),
        })
        return
      }
      const item = (this.allWarehouseList || []).find((w) => w.uniqueCode === selectedKey)
      if (!item) return
      const type = this.returnWarehouseModalType
      const entry = {
        warehouseCode: item.code,
        warehouseName: item.name,
        wmsApp: item.wmsAppCode,
        type,
        typeName: this.RETURN_WAREHOUSE_TYPE_MAP[type],
        uniqueCode: item.uniqueCode,
      }
      const list = (this.formData.returnWarehouseList || []).filter((w) => w.type !== type)
      list.push(entry)
      this.$set(this.formData, 'returnWarehouseList', list)
      this.returnWarehouseModalVisible = false
    },
    handleReturnWarehouseModalCancel() {
      this.returnWarehouseModalVisible = false
    },
    getSelectedReturnWarehouse(type) {
      return (this.formData.returnWarehouseList || []).find((w) => w.type === type)
    },
    clearReturnWarehouse(type) {
      const list = (this.formData.returnWarehouseList || []).filter((w) => w.type !== type)
      this.$set(this.formData, 'returnWarehouseList', list)
    },
    buildReturnWarehouseListPayload() {
      return (this.formData.returnWarehouseList || []).map(
        ({ warehouseCode, warehouseName, wmsApp, type, typeName }) => ({
          warehouseCode,
          warehouseName,
          wmsApp,
          type,
          typeName,
        })
      )
    },
    openWarehouseModal() {
      this.warehouseModalVisible = true
      this.fetchAllWarehouseList()
      // 预勾选已选中的仓库
      this.warehouseModalSelectedRowKeys =
        (this.formData.warehouseList || []).map((item) => item.uniqueCode) || []
    },
    async fetchAllWarehouseList() {
      if (this.allWarehouseList.length) return this.allWarehouseList
      this.warehouseTableLoading = true
      try {
        const res = await http({
          url: api.queryWarehousePageWithShipper,
          type: 'post',
          data: {
            merchantCode: this.$store.state.userSession.merchantCode,
            status: true,
          },
        })
        this.allWarehouseList = res.result.list || []
        return this.allWarehouseList
      } finally {
        this.warehouseTableLoading = false
      }
    },
    onWarehouseModalSelectChange(selectedRowKeys) {
      this.warehouseModalSelectedRowKeys = selectedRowKeys
    },
    handleWarehouseModalOk() {
      const selectedSet = new Set(this.warehouseModalSelectedRowKeys || [])
      const list = (this.allWarehouseList || [])
        .filter((item) => selectedSet.has(item.uniqueCode))
        .map((item) => ({
          warehouseCode: item.code,
          warehouseName: item.name,
          wmsApp: item.wmsAppCode,
          uniqueCode: item.uniqueCode,
          defaultWarehouse: 0,
        }))
      // 如果之前已经有默认仓，保持同一个仓为默认（若还在选中列表中）
      const oldDefault =
        (this.formData.warehouseList || []).find((w) => w.defaultWarehouse === 1) || {}
      if (oldDefault.warehouseCode) {
        const keep = list.find((w) => w.warehouseCode === oldDefault.warehouseCode)
        if (keep) {
          keep.defaultWarehouse = 1
        }
      }
      // 如果还没有默认仓，则把第一条设为默认
      if (!list.some((w) => w.defaultWarehouse === 1) && list.length) {
        list[0].defaultWarehouse = 1
      }
      this.$set(this.formData, 'warehouseList', list)
      this.warehouseModalVisible = false
    },
    handleWarehouseModalCancel() {
      this.warehouseModalVisible = false
    },
    setDefaultWarehouse(record) {
      // 当前行设为默认，其余设为非默认
      ;(this.formData.warehouseList || []).forEach((item) => {
        item.defaultWarehouse = item.uniqueCode === record.uniqueCode ? 1 : 0
      })
    },
    async fetchVirtualServiceProvider(merchantCode) {
      try {
        const res = await http({
          url: api.listServiceProvider,
          type: 'post',
          data: {
            country: 'CN',
            merchantCode,
          },
        })
        const list = res?.result || []
        return list.find((item) => item.wmsAppCode === 'VIRTUAL_WMS') || null
      } catch (error) {
        this.$error({ title: this.$t(`layer.Error`), content: this.$t('获取服务商失败') })
        return null
      }
    },
    async fetchSettlementDepartment(merchantCode) {
      try {
        const res = await http({
          url: api.getDepartmentList,
          type: 'post',
          data: {
            merchantCode,
          },
        })
        const list = res?.result || []
        if (!list.length) return null
        return list[list.length - 1]
      } catch (error) {
        this.$error({ title: this.$t(`layer.Error`), content: this.$t('获取结算组织失败') })
        return null
      }
    },
    generateVirtualWarehouseCode() {
      let code = ''
      const exists = (this.allWarehouseList || []).map((item) => item.code)
      do {
        code = `VIR${Date.now().toString(36)}${Math.random()
          .toString(36)
          .slice(2, 6)}`.toUpperCase()
      } while (exists.includes(code))
      return code
    },
    async createVirtualWarehouse() {
      const merchantCode = localStorage.getItem('merchantCode') || ''
      const merchantName = localStorage.getItem('merchantName') || this.formData.supplierName || ''
      const provider = await this.fetchVirtualServiceProvider(merchantCode)
      if (!provider) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('未找到代发仓服务商，无法创建代发仓'),
        })
        return null
      }
      const department = await this.fetchSettlementDepartment(merchantCode)
      if (!department) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('未获取到结算组织，无法创建代发仓'),
        })
        return null
      }
      const warehouseCode = this.generateVirtualWarehouseCode()
      const warehouseName = `觅之简-${this.formData.supplierName || ''}-代发仓`
      const warehousePayload = {
        country: 'CN',
        name: warehouseName,
        code: warehouseCode,
        settlementBuCode: department.code,
        settlementBuName: department.name,
        type: 'VIRTUAL',
        // 按供应商填写/选择的信息赋值
        contactPerson: this.formData.linkman || '',
        telephone: this.formData.mobile || '',
        email: this.formData.email || '',
        provinceId: Number(this.delivery?.[1]) || undefined,
        province: this.addressNameList?.[1] || '',
        cityId: Number(this.delivery?.[2]) || undefined,
        city: this.addressNameList?.[2] || '',
        districtId: Number(this.delivery?.[3]) || undefined,
        district: this.addressNameList?.[3] || '',
        address: this.formData.address || '',
        countryId: this.delivery?.[0],
      }
      const res = await http({
        url: api.saveShipperWarehouse,
        type: 'post',
        hasLoading: true,
        data: {
          shipper: {
            name: merchantName,
            code: merchantCode,
            key: merchantCode,
            secret: merchantCode,
            merchantCode,
            merchantAppCode: provider.code,
            wmsAppCode: 'VIRTUAL_WMS',
            baseUrl: 'VIRTUAL_WMS',
          },
          warehouseList: [warehousePayload],
          merchantCode,
        },
      })
      if (!res?.success) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: res?.msg || this.$t('创建代发仓失败'),
        })
        return null
      }
      const warehouseListRes = res?.result?.warehouseList || []
      const warehouseRes = warehouseListRes[0] || {}
      const code = warehouseRes.code || warehousePayload.code
      const name = warehouseRes.name || warehousePayload.name
      const wmsAppCode = warehouseRes.wmsAppCode || provider.wmsAppCode || 'VIRTUAL_WMS'
      const uniqueCode = warehouseRes.uniqueCode || `${wmsAppCode}_${code}`
      const virtualInfo = {
        warehouseCode: code,
        warehouseName: name,
        wmsApp: wmsAppCode,
        uniqueCode,
        defaultWarehouse: 0,
        type: 'VIRTUAL',
      }
      this.allWarehouseList = [
        {
          ...warehousePayload,
          code,
          name,
          uniqueCode,
          wmsAppCode,
          type: 'VIRTUAL',
        },
        ...this.allWarehouseList,
      ]
      return virtualInfo
    },
    async prepareWarehousesForCreate() {
      await this.fetchAllWarehouseList()
      const physicalWarehouses = (this.allWarehouseList || []).filter(
        (item) => item.type === 'PHYSICAL'
      )
      if (!physicalWarehouses.length) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('暂无实体仓可关联，请先创建实体仓库'),
        })
        return false
      }
      let warehouses = physicalWarehouses.map((item) => ({
        warehouseCode: item.code,
        warehouseName: item.name,
        wmsApp: item.wmsAppCode,
        uniqueCode: item.uniqueCode || `${item.wmsAppCode}_${item.code}`,
        defaultWarehouse: 0,
        type: item.type,
      }))
      if (this.supportDropshipping) {
        const virtualWarehouse = await this.createVirtualWarehouse()
        if (!virtualWarehouse) {
          return false
        }
        warehouses = [virtualWarehouse, ...warehouses]
      }
      if (warehouses.length) {
        warehouses = warehouses.map((item, index) => ({
          ...item,
          defaultWarehouse: index === 0 ? 1 : 0,
        }))
      }
      this.$set(this.formData, 'warehouseList', warehouses)
      return true
    },
    async loadData(selectedOptions) {
      this.type = selectedOptions.length
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      await http({
        url: api.getRegionAdd,
        type: 'post',
        data: {
          regionType: this.type,
          parentId: targetOption.region_id,
        },
        success: (res) => {
          let data = res.result
          targetOption.loading = false
          targetOption.children = [...data]
          if (this.type <= 3) {
            targetOption.children = [...data].map((item) => {
              item.isLeaf = selectedOptions.length === 3 // deep 为指名数据的层级
              return item
            })
          }

          this.options = [...this.options]
        },
      }) // 接口调用
    },
    checkMinPrepayment(rule, value, callback) {
      if (value === '') {
        callback()
      }
      if (!/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/.test(value)) {
        callback(new Error('Must be a number greater than 0'))
      }
      callback()
    },
    selectSupplierAddress(e, a) {
      // console.log('e: ', e, a)
      this.delivery = [...e]
      this.addressNameList = a?.map((item) => item.display_name) || []
    },
    async editUser(deliveryArr) {
      let promiseList = deliveryArr.slice(0, -1).map((item, index) => {
        let obj = {
          regionType: index + 1,
          parentId: item,
        }
        return new Promise(function (resolve) {
          http({
            url: api.getRegionAdd,
            hasLoading: true,
            type: 'post',
            data: obj,
            success: (res) => {
              resolve(res.result)
            },
          })
        })
      })
      Promise.all(promiseList).then((res) => {
        const data = res.reduceRight((a, b, index) => {
          b.forEach((item) => {
            // console.log('index: ', index, item)
            item.isLeaf = index === 2
            if (a[0]?.parent_id == item.region_id) {
              item.children = a
            }
          })
          return b
        }, [])
        this.options.forEach((item) => {
          if (item.region_id == data[0].parent_id) {
            item.children = data
          }
        })
        this.delivery = this.deliveryArr
      })
    },
    getDetail() {
      if (this.$route.query.id) {
        this.supplierCode = this.$route.query.id
        this.isEdit = true
        http({
          url: api.supplierDetail,
          hasLoading: true,
          type: 'post',
          data: {
            supplierCode: this.supplierCode,
          },
          success: (res) => {
            this.formData = res.result
            this.$set(this.formData, 'vatRate', res.result.vatRate ?? undefined)
            // 仓库表格及默认仓库回显
            this.formData.warehouseList = (res.result.warehouseList || []).map((w) => ({
              warehouseCode: w.warehouseCode || w.code,
              warehouseName: w.warehouseName || w.name,
              wmsApp: w.wmsApp || w.wmsAppCode,
              uniqueCode:
                w.uniqueCode || `${w.wmsApp || w.wmsAppCode}_${w.warehouseCode || w.code}`,
              defaultWarehouse: w.defaultWarehouse === 1 ? 1 : 0,
            }))
            this.formData.returnWarehouseList = (res.result.returnWarehouseList || []).map((w) => ({
              warehouseCode: w.warehouseCode,
              warehouseName: w.warehouseName,
              wmsApp: w.wmsApp || w.wmsAppCode,
              type: w.type,
              typeName: w.typeName || this.RETURN_WAREHOUSE_TYPE_MAP[w.type],
              uniqueCode: w.uniqueCode || `${w.wmsApp || w.wmsAppCode}_${w.warehouseCode}`,
            }))
            // 供应商地址回显
            // 付款计划设置回显
            this.paymentPlanSettings = (res.result.paymentPlanSettings || []).map((item) => ({
              isPrepay: item.isPrepay,
              ratio: item.ratio,
            }))
            this.deliveryArr = [
              res.result.country * 1,
              res.result.province * 1,
              res.result.city * 1,
              res.result.district * 1,
            ]
            this.addressNameList = [
              res.result.countryName,
              res.result.provinceName,
              res.result.cityName,
              res.result.districtName,
            ]
            this.editUser(this.deliveryArr)
            // 图片回显
            if (this.formData.businessLicense) {
              this.businessLicenseList = [
                {
                  uid: res.result.businessLicense?.ossId ?? 1,
                  name: 'businessLicense',
                  status: 'done',
                  url: res.result.businessLicense?.url,
                  partyFileId: res.result.businessLicense?.ossId,
                },
              ]
            } else {
              this.businessLicenseList = []
            }
            if (this.formData.idCardFront) {
              this.idCardFrontList = [
                {
                  uid: res.result.idCardFront?.ossId ?? 1,
                  name: 'idCardFront',
                  status: 'done',
                  url: res.result.idCardFront?.url,
                  partyFileId: res.result.idCardFront?.ossId,
                },
              ]
            } else {
              this.idCardFrontList = []
            }
            if (this.formData.idCardReverse) {
              this.idCardReverseList = [
                {
                  uid: res.result.idCardReverse?.ossId ?? 1,
                  name: 'idCardReverse',
                  status: 'done',
                  url: res.result.idCardReverse?.url,
                  partyFileId: res.result.idCardReverse?.ossId,
                },
              ]
            } else {
              this.idCardReverseList = []
            }
            if (this.formData.attachments) {
              this.otherAttachmentsList = [...res.result.attachments].map((v) => ({
                uid: v.ossId,
                name: v.name,
                status: 'done',
                url: v.url,
                partyFileId: v.ossId,
              }))
            } else {
              this.otherAttachmentsList = []
            }

            this.$forceUpdate()
          },
        })
      } else {
        this.formData.currency = this.currentShop.currency
      }
    },
    getMerchantRefetList() {
      http({
        url: api.getMerchantRefetList,
        data: {
          merchantId: localStorage.getItem('merchantId'),
        },
        success: (res) => {
          this.merchantList = res.result.list || []
        },
      })
    },
    // 取消编辑
    cancelEdit() {
      this.isShow = !this.isShow
      this.getDetail()
    },
    // 警告弹窗
    warningModal(text) {
      this.$warning({
        title: this.$t(`layer.Warning`),
        content: this.$t(text) + ' ' + this.$t('form.Required'),
      })
    },
    onSubmit: debounce(async function () {
      // 校验
      if (!this.formData.supplierName) {
        this.warningModal('form.SupplierName')
        return
      }
      if (this.delivery.length === 0) {
        this.warningModal('form.SupplierAddress')
        return
      }
      // if (!this.formData.postCode) {
      //   this.warningModal('form.Postcode')
      //   return
      // }
      if (!this.formData.address) {
        this.warningModal('form.SupplierDetailedAddress')
        return
      }
      if (!this.formData.linkman) {
        this.warningModal('form.ContactPerson')
        return
      }
      if (!this.formData.mobile) {
        this.warningModal('form.ContactInformation')
        return
      }
      // if (!/^\d{11}$/.test(this.formData.mobile)) {
      //   this.$warning({
      //     title: this.$t(`layer.Warning`),
      //     content: 'The length of mobile does not match',
      //   })
      //   return
      // }
      if (!this.formData.bizMode) {
        this.warningModal('form.BizMode')
        return
      }
      if (!this.formData.bankName) {
        this.warningModal('form.BankOfDeposit')
        return
      }
      if (!this.formData.bankAccount) {
        this.warningModal('form.BankAccount')
        return
      }
      if (!this.formData.currency) {
        this.warningModal('form.Currency')
        return
      }
      // 校验付款计划设置
      if (this.paymentPlanSettings.length > 0) {
        for (let i = 0; i < this.paymentPlanSettings.length; i++) {
          const item = this.paymentPlanSettings[i]
          if (item.isPrepay === undefined || item.isPrepay === null || item.isPrepay === '') {
            this.$warning({
              title: this.$t('layer.Warning'),
              content: this.$t('付款计划设置第') + (i + 1) + this.$t('行：是否预付不能为空'),
            })
            return
          }
          if (item.ratio === undefined || item.ratio === null || item.ratio === '') {
            this.$warning({
              title: this.$t('layer.Warning'),
              content: this.$t('付款计划设置第') + (i + 1) + this.$t('行：支付比例不能为空'),
            })
            return
          }
          if (item.ratio <= 0) {
            this.$warning({
              title: this.$t('layer.Warning'),
              content: this.$t('付款计划设置第') + (i + 1) + this.$t('行：支付比例必须大于0'),
            })
            return
          }
        }
        const totalRatio = this.paymentPlanSettings.reduce(
          (sum, item) => sum + Number(item.ratio),
          0
        )
        if (Math.abs(totalRatio - 100) > 0.001) {
          this.$warning({
            title: this.$t('layer.Warning'),
            content:
              this.$t('付款计划设置：所有支付比例之和必须等于100%，当前合计为') +
              totalRatio.toFixed(2) +
              '%',
          })
          return
        }
      }
      // 开始调用接口前置为 true
      this.saveLoading = true
      // 非租户模式下不展示/不保存仓库与一件代发相关逻辑
      if (!this.isRent) {
        this.supportDropshipping = false
        this.$set(this.formData, 'warehouseList', [])
        this.$set(this.formData, 'returnWarehouseList', [])
      }
      if (this.isRent && !this.isEdit) {
        const prepared = await this.prepareWarehousesForCreate()
        if (!prepared) {
          this.saveLoading = false
          return
        }
      }
      if (this.isRent && this.formData.warehouseList && this.formData.warehouseList.length > 0) {
        const hasDefault = this.formData.warehouseList.some((item) => item.defaultWarehouse === 1)
        if (!hasDefault) {
          this.saveLoading = false
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t('请选择默认仓库'),
          })
          return
        }
        // 确保只有一个默认仓（如果后端有要求的话，这里可以强制规范）
        let found = false
        this.formData.warehouseList = this.formData.warehouseList.map((item) => {
          if (item.defaultWarehouse === 1) {
            if (found) {
              return { ...item, defaultWarehouse: 0 }
            }
            found = true
            return { ...item, defaultWarehouse: 1 }
          }
          return { ...item, defaultWarehouse: 0 }
        })
      }
      this.formData.businessLicense = []
      this.formData.idCardFront = []
      this.formData.idCardReverse = []
      this.formData.otherAttachments = []
      if (!this.$route.query.id) {
        this.businessLicenseList.forEach((v, i) => {
          this.formData.businessLicense.push({
            type: 1,
            url: v.url,
            ossId: v.response.result.ossId,
            name: 'businessLicense',
            originalName: v.name,
            idx: i + 1,
          })
        })
        this.formData.businessLicense = this.formData.businessLicense[0]
        this.idCardFrontList.forEach((v, i) => {
          this.formData.idCardFront.push({
            type: 1,
            url: v.url,
            ossId: v.response.result.ossId,
            name: 'idCardFront',
            originalName: v.name,
            idx: i + 1,
          })
        })
        this.formData.idCardFront = this.formData.idCardFront[0]
        this.idCardReverseList.forEach((v, i) => {
          this.formData.idCardReverse.push({
            type: 1,
            url: v.url,
            ossId: v.response.result.ossId,
            name: 'idCardReverse',
            originalName: v.name,
            idx: i + 1,
          })
        })
        this.formData.idCardReverse = this.formData.idCardReverse[0]
        this.otherAttachmentsList.forEach((v, i) => {
          this.formData.otherAttachments.push({
            type: 1,
            url: v.url,
            ossId: v.response.result.ossId,
            name: 'other',
            originalName: v.name,
            idx: i + 1,
          })
        })
      } else {
        this.formData.supplierCode = this.$route.query.id
        if (this.businessLicenseList.length) {
          if (this.businessLicenseList[0].lastModified) {
            this.formData.businessLicense = {
              type: 1,
              url: this.businessLicenseList[0].url,
              ossId: this.businessLicenseList[0].response.result.ossId,
              name: 'businessLicense',
              originalName: this.businessLicenseList[0].name,
              idx: 1,
            }
          } else {
            this.formData.businessLicense = {
              idx: 1,
              name: 'businessLicense',
              originalName: this.businessLicenseList[0].name,
              ossId: this.businessLicenseList[0].ossId,
              type: 1,
              url: this.businessLicenseList[0].url,
            }
          }
        } else {
          this.formData.businessLicense = ''
        }
        if (this.idCardFrontList.length) {
          if (this.idCardFrontList[0].lastModified) {
            this.formData.idCardFront = {
              type: 1,
              url: this.idCardFrontList[0].url,
              ossId: this.idCardFrontList[0].response.result.ossId,
              name: 'idCardFront',
              originalName: this.idCardFrontList[0].name,
              idx: 1,
            }
          } else {
            this.formData.idCardFront = {
              idx: 1,
              name: 'idCardFront',
              originalName: this.idCardFrontList[0].name,
              ossId: this.idCardFrontList[0].ossId,
              type: 1,
              url: this.idCardFrontList[0].url,
            }
          }
        } else {
          this.formData.idCardFront = ''
        }
        if (this.idCardReverseList.length) {
          if (this.idCardReverseList[0].lastModified) {
            this.formData.idCardReverse = {
              type: 1,
              url: this.idCardReverseList[0].url,
              ossId: this.idCardReverseList[0].response.result.ossId,
              name: 'idCardReverse',
              originalName: this.idCardReverseList[0].name,
              idx: 1,
            }
          } else {
            this.formData.idCardReverse = {
              idx: 1,
              name: 'idCardReverse',
              originalName: this.idCardReverseList[0].name,
              ossId: this.idCardReverseList[0].ossId,
              type: 1,
              url: this.idCardReverseList[0].url,
            }
          }
        } else {
          this.formData.idCardReverse = ''
        }
        if (this.otherAttachmentsList.length) {
          let achments = []
          this.otherAttachmentsList.forEach((v, i) => {
            if (v.lastModified) {
              achments.push({
                type: 1,
                url: v.url,
                ossId: v.response.result.ossId,
                name: 'other',
                originalName: v.name,
                idx: i + 1,
              })
            } else {
              achments.push({
                idx: i + 1,
                name: 'other',
                originalName: v.name,
                ossId: v.partyFileId,
                type: 1,
                url: v.url,
              })
            }
          })
          this.formData.otherAttachments = [...achments]
        } else {
          this.formData.otherAttachments = []
        }
      }
      this.formData.country = this.delivery[0]
      this.formData.province = this.delivery[1]
      this.formData.city = this.delivery[2]
      this.formData.district = this.delivery[3]

      this.formData.countryName = this.addressNameList[0]
      this.formData.provinceName = this.addressNameList[1]
      this.formData.cityName = this.addressNameList[2]
      this.formData.districtName = this.addressNameList[3]
      // 将 paymentPlanSettings 附加到提交数据
      const submitData = {
        ...this.formData,
        returnWarehouseList: this.buildReturnWarehouseListPayload(),
        paymentPlanSettings: this.paymentPlanSettings.map((item) => ({
          isPrepay: item.isPrepay,
          ratio: item.ratio,
        })),
      }
      http({
        url: this.$route.query.id ? api.supplierUpdate : api.supplierCreate,
        data: submitData,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          this.saveLoading = false
          if (res.success && res.result.supplierCode) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
            if (this.$route.query.from) {
              this.$router.push(this.$route.query.from)
            } else if (this.$route.query.id) {
              this.isShow = !this.isShow
              this.getDetail()
            } else {
              this.$router.back()
            }
            this.$nextTick(() => {
              this.$store.dispatch('querySupplierList')
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
        },
        fail: (res) => {
          this.saveLoading = false
          this.$error(res.msg)
        },
      })
    }),
    updateStatusFn(status) {
      http({
        url: api.supplierBatchUpdateStatus,
        data: {
          supplierCodes: [this.supplierCode],
          status,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.StatusSuccessfully`),
            })
            this.getDetail()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.StatusFailed`),
            })
          }
        },
      })
    },
    backForm() {
      this.$router.back()
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    addPaymentPlanSetting() {
      this.paymentPlanSettings.push({ isPrepay: 1, ratio: undefined })
    },
    removePaymentPlanSetting(index) {
      this.paymentPlanSettings.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.ant-upload :deep(img) {
  width: 100px;
  height: 100px;
}
</style>
